import declare from "dojo/_base/declare";
import AddToAffectedItemsController from "./AddToAffectedItemsController";
import AffectedItemsGroupController from "./AffectedItemsGroupController";

const AddToAffectedItemsGroupController = declare([AffectedItemsGroupController, AddToAffectedItemsController], {
});

export = AddToAffectedItemsGroupController;